import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledPercentageBarByCollectionLocation = styled(Box, {
  display: 'flex',
  padding: '$7 $8',
  border: '$borderWidths$1 solid $seafoam500',
  borderRadius: '$6',
});

export const StyledPercentageBarByCollectionLocationTitle = styled(Box, {
  fontWeight: '$bold',
  fontSize: '$md',
  lineHeight: '$6',
  marginRight: '96px',
  color: '$darkBlue400',
});

export const StyledPercentageBarChart = styled(Box, { flexGrow: '1' });
